"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuery = void 0;
const tslib_1 = require("tslib");
const client_1 = require("@apollo/client");
const Client_1 = require("../Client");
function useQuery(query, options) {
    const gqlQuery = Client_1.stringToGQL(query);
    const _a = client_1.useQuery(gqlQuery, options), { data, error } = _a, result = tslib_1.__rest(_a, ["data", "error"]);
    return Object.assign({ data: !result.loading && !error ? Client_1.extractGqlData(data) : undefined, error: error ? error : undefined }, result);
}
exports.useQuery = useQuery;
//# sourceMappingURL=useQuery.js.map